module.exports = require("core-js/library/fn/object/freeze");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/freeze.js
// module id = 546
// module chunks = 92